import React from 'react';
import './ToggleSwitch.css';

/**
 * 🎛️ ELEGANT TOGGLE SWITCH COMPONENT
 * 
 * Perfekt für das neue ImageContainer System.
 * Lean, accessible und branding-konform.
 */
function ToggleSwitch({ 
    label, 
    fieldName, 
    checked = false, 
    onChange,
    size = 'default', // default|small|large
    color = '#5C80BC',
    disabled = false,
    showLabel = true
}) {
    
    const handleToggle = () => {
        if (disabled || !onChange) return;
        
        const fakeEvent = {
            target: {
                name: fieldName,
                value: !checked,
                type: 'checkbox',
                checked: !checked
            }
        };
        onChange(fakeEvent);
    };

    return (
        <div className={`bc-toggle-switch-container bc-${size} ${disabled ? 'bc-disabled' : ''}`}>
            {showLabel && label && (
                <label className="bc-toggle-switch-label">{label}</label>
            )}
            
            <button
                type="button"
                className={`bc-toggle-switch ${checked ? 'bc-checked' : ''} bc-${size}`}
                onClick={handleToggle}
                disabled={disabled}
                role="switch"
                aria-checked={checked}
                aria-label={label}
                style={{ '--bc-toggle-color': color }}
            >
                <span className="bc-toggle-switch-track">
                    <span className="bc-toggle-switch-thumb"></span>
                </span>
            </button>
        </div>
    );
}

export default ToggleSwitch;